import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam, IFileDownload } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { Router, UrlSerializer } from '@angular/router';

@Component({
  selector: 'app-exam-script',
  templateUrl: './exam-script.component.html',
  styleUrls: ['./exam-script.component.scss']
})
export class ExamScriptComponent implements OnInit {
  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  skipImportCandidateData = false;
  exam: IExam = examDefault;
  constructor(private popoverRef: PopoverRef<ExamScriptComponent>,
    private examService: ExamService, private router: Router,
    private snackBar: SnackbarService, private serializer: UrlSerializer) { }

  async ngOnInit() {

  }

  close() {
    this.popoverRef.close();
  }
  getExamScriptReport() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
      const reportTree = this.router.createUrlTree([], { queryParams: { "examinationID": this.exam.id, "skipImportCandidateData": this.skipImportCandidateData } });
      let params = this.serializer.serialize(reportTree).split('?', 2)[1];
      this.examService.getExamScriptReport(this.exam.id, params).then((s: IFileDownload) => {
        this.snackBar.success('Report Successfull');
        this.exportedFile = s;
      })
    }
  }
}
